module.exports = __webpack_public_path__ + "static/img/intent_of_use_acknowledgement.16f1ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intent_of_use_acknowledgement.png
// module id = ySry
// module chunks = 4